import { Title } from "@humanpredictiveintelligence/myqvt-library"
import styled, { css } from "styled-components/macro"

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    padding: 48px 56px;
    height: 100%;
    overflow: hidden;
  `}
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 32px;
`

export const ButtonContainer = styled.div`
  display: flex;
  gap: 2rem;
`

export const QuestionTitle = styled(Title)`
  margin: 0 0 32px 0;
`
